export default "__VITE_ASSET__CNUYZ$jD__"